import service from '@/services/modules/helpers/qr'

export default {
  GET_QR(_, params) {
    return new Promise((resolve, reject) => {
      service.getQR(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
